import axios from 'axios';
import store from '../store'
import router from "../router";

class ExternalUserRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    async getOrCreateExternalUser(externalUser) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/external-user`,externalUser,{headers:headers});
        response.catch((error) => {if(error.response.status === 401) {store.commit('clearData'); router.push('/'); }});  // Go to login to re-authenticate
        return response;
    }
}

export default new ExternalUserRepository();
